import script from "./BookList.vue?vue&type=script&setup=true&lang=js"
export * from "./BookList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__